import React, { useState } from 'react';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './Search.css';

const Search = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  const titleText = useTranslatedText('Etkinlik Ara');
  const placeholderText = useTranslatedText('Etkinlik Adı Giriniz');
  const buttonText = useTranslatedText('Ara');

  const handleSearch = () => {
    onSearch(query);
  };

  return (
    <section className="search-container">
      <div className="search">
        <h1>{titleText}</h1>
        <div className="search-bar">
          <input type="text" placeholder={placeholderText} value={query} onChange={(e) => setQuery(e.target.value)} />
          <button onClick={handleSearch}>{buttonText}</button>
        </div>
      </div>
    </section>
  );
};

export default Search;

